import React, { ChangeEvent } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import { StringInput } from 'src/shared/ui/_inputs/StringInput';
import s from './PercentageField.module.scss';
import cn from 'classnames';

export const PercentageField: React.FC<GeneratedField> = (props) => {
	const { namePrefix, propertyName, internalName, validate, measureUnits, handlingType } = props;

	// * Form
	const { setValue, control } = useFormContext();

	const existence = useWatch({
		name: `${namePrefix}${propertyName}.existence.value`,
	});

	const name = `${namePrefix}${propertyName}.${internalName}`;

	// Delta percentage handling type only...
	const percentageName = `${namePrefix}${propertyName}.percentage`;
	const deltaName = `${namePrefix}${propertyName}.delta`;
	//...

	const textFieldOnChangeHandler = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, fieldName: string) => {
		if (handlingType === 'normal' || handlingType === 'target') {
			if (event.target.value === '' || event.target.value === '.') {
				setValue(fieldName, null);
			} else if (event.target.value.match(/^[-0-9]*\.?[0-9]*$/g)) {
				setValue(fieldName, event.target.value);
			} else return;
		}

		if (handlingType === 'deltaPercentage') {
			if (event.target.value === '' || event.target.value === '.') {
				setValue(`${percentageName}.value`, null);
				setValue(`${deltaName}.value`, null);
			} else if (event.target.value.match(/^[-0-9]*\.?[0-9]*$/g)) {
				if (internalName === 'delta') {
					setValue(`${deltaName}.value`, event.target.value);

					const percentageValue = (100 - +event.target.value).toString();

					setValue(`${percentageName}.value`, percentageValue);
				}

				if (internalName === 'percentage') {
					setValue(`${percentageName}.value`, event.target.value);

					const deltaValue = (100 - +event.target.value).toString();

					setValue(`${deltaName}.value`, deltaValue);
				}
			} else return;
		}
	};

	// Target Fields only ...
	const disableBasedOnExistence = existence === null || existence === 'false';

	// * Conditions
	const isSmaller = internalName === 'delta' || internalName == 'target' || internalName === 'percentage';

	return (
		<Controller
			name={`${name}.value`}
			control={control}
			rules={{ validate: validate }}
			render={({ field, fieldState }) => (
				<div>
					<div className={s.fieldWrapper}>
						{handlingType === 'deltaPercentage' && <span className={s.additionalTextLeft}>{internalName}</span>}

						<StringInput
							{...field}
							className={cn(s.textField, isSmaller && s.textField_small)}
							value={field.value === null ? '' : field.value}
							onChange={(e) => textFieldOnChangeHandler(e, field.name)}
							disabled={disableBasedOnExistence}
							suffix={measureUnits ?? undefined}
							size="middle"
						/>
					</div>

					{fieldState.error && <span className={s.error}>{fieldState.error.message}</span>}
				</div>
			)}
		/>
	);
};
